module.exports = __webpack_public_path__ + "static/media/LoginSideImage.eb8a3709.png";